'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Link component, renders a native `a` element.
 *
 * @example
 * <Link href='#'>Link</Link>
 */
const Link = forwardRef(({ asChild, className, ...rest }, ref) => {
    const Component = asChild ? Slot : 'a';
    return (jsx(Component, { className: cl('ds-link', className), ref: ref, ...rest }));
});
Link.displayName = 'Link';

export { Link };
